var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap",class:{ 'is-header': _vm.$route.meta.header }},[_c('transition',[_c('page-header',{ref:"pageHeader",on:{"main-icon-click":_vm.handleMain,"back-icon-click":_vm.handleBack}})],1),_c('transition',[_c('router-view',{ref:"routerView"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }